import ChallengeCaptcha from '../graphql/queries/challengeCaptcha.query.gql'
import { GraphQLClient } from 'graphql-request'

const apolloFederationUrl = process.env.VUE_APP_APOLLO_FEDERATION_URL

const createClient = (accountId, token, extraHeaders = {}) => {
  return new GraphQLClient(apolloFederationUrl, {
    headers: {
      accountid: accountId,
      recaptchatoken: token,
      ...extraHeaders
    }
  })
}

const executeRequest = async (client, gql, params) => {
  const response = await client.request(gql, params)
  if (response.errors) {
    throw new Error(response.errors[0].message)
  }
  return response
}

export const generateCaptchaToken = captchaKey => {
  return window.grecaptcha.execute(captchaKey, { action: 'SIGNUP' })
}

export const validateCaptchaToken = async (captchaKey, accountId) => {
  const client = new GraphQLClient(apolloFederationUrl, {
    headers: {
      accountid: accountId
    }
  })
  const token = await generateCaptchaToken(captchaKey)

  const { errors } = await client.request(ChallengeCaptcha, { token })

  if (errors) {
    throw new Error(errors[0].message)
  }

  return token
}

export const doCaptchaGuardedRequest = async (gql, params, captchaKey, accountId, currentToken, extraHeaders = {}) => {
  let token = currentToken
  try {
    if (!token) {
      token = await validateCaptchaToken(captchaKey, accountId)
    }

    const client = createClient(accountId, token, extraHeaders)
    const data = await executeRequest(client, gql, params)
    return { data, token }
  } catch (error) {
    // If error isn't captcha-related, throw
    if (!['Captcha token has been used too many times', 'Captcha token has expired'].includes(error?.response?.errors?.[0]?.message)) {
      throw error
    }

    // Generate new token and retry once
    token = await validateCaptchaToken(captchaKey, accountId)
    const client = createClient(accountId, token, extraHeaders)
    const data = await executeRequest(client, gql, params)
    return { data, token }
  }
}
